import { combineReducers, configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import rootsaga from './root-sagas'
import { userSlice } from './userredux/user_slice'
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer
} from 'redux-persist'
// import storage from 'redux-persist/lib/storage'
import storageSession from 'redux-persist/lib/storage/session'
import { restaurantSlice } from './userredux/restaurant_slice'
import loaderReducer from './userredux/loader_slice'
import menuReducer from './userredux/menu_slice'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const middleWares: any[] = []
const persistConfig = {
  key: 'root',
  storage: storageSession,
  whitelist: ['user', 'restaurant']
}
const reducers = combineReducers({
  restaurant: restaurantSlice.reducer,
  user: userSlice.reducer,
  loader: loaderReducer,
  menu: menuReducer
})
const persistedReducer = persistReducer(persistConfig, reducers)
const SagaMiddleware = createSagaMiddleware()
middleWares.push(SagaMiddleware)
// const middleware = [SagaMiddleware];
const devToolsReq = process.env.NODE_ENV === 'development' ? true : false
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }).prepend(middleWares),
  devTools: devToolsReq
})

SagaMiddleware.run(rootsaga)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
